import React, { memo } from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
export function WhatYouGetSection() {
  const items = [{
    title: 'Guía Digital "Menopausia Sin Niebla"',
    desc: 'El manual paso a paso para reactivar tu enfoque.'
  }, {
    title: 'El Protocolo Neuro-Flash',
    desc: 'Recetas de 10 minutos que blindan tu memoria por 8 horas al día.'
  }, {
    title: 'Lista de Saboteadores Ocultos',
    desc: 'Los 3 ingredientes que debes eliminar hoy para dejar de olvidar nombres en público.'
  }, {
    title: 'Técnica de Rescate en Público',
    desc: 'El truco psicológico para recuperar un dato bloqueado en segundos.'
  }, {
    title: 'Checklist de Claridad de 7 Días',
    desc: 'Tu hoja de ruta diaria para medir cómo regresa tu agudeza.'
  }];
  return <section className="w-full bg-white py-20 px-6 border-y border-cream-dark" data-id="element-137">
      <div className="max-w-4xl mx-auto" data-id="element-138">
        <FadeIn data-id="element-139">
          <h2 className="text-3xl md:text-4xl font-bold mb-12 text-center" data-id="element-140">
            Todo lo que recibes hoy
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12" data-id="element-141">
            {items.map((item, index) => <div key={index} className={`bg-cream p-6 rounded-xl border border-cream-dark flex flex-col ${index === items.length - 1 ? 'md:col-span-2 md:w-1/2 md:mx-auto' : ''}`} data-id="element-142">
                <div className="flex items-center gap-3 mb-3" data-id="element-143">
                  <svg className="w-6 h-6 text-sage flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-144">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-145" />
                  </svg>
                  <h3 className="text-xl font-bold text-sage m-0" data-id="element-146">
                    {item.title}
                  </h3>
                </div>
                <p className="text-charcoal-light ml-9" data-id="element-147">{item.desc}</p>
              </div>)}
          </div>

          <div className="flex justify-center" data-id="element-148">
            <Button data-id="element-149">SÍ, QUIERO ACCEDER AL PROTOCOLO</Button>
          </div>
        </FadeIn>
      </div>
    </section>;
}